var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BarChart from "../../molecules/graphs/BarChart";
import { Status } from "../../../redux/constants/status";
import PieChart from "../../molecules/graphs/pieChart";
import StackedBar from "../../molecules/graphs/stackedBar";
var DashboardGraps = function (props) {
    var barData = {
        status: Status.Loading,
        labels: undefined,
        values: undefined,
        datasets: undefined,
    };
    var rightSideData = {
        status: Status.Loading,
        labels: undefined,
        values: undefined,
        userType: props.userType,
    };
    if (props.groupedData) {
        barData = {
            status: Status.Successful,
            labels: props.groupedData.labels,
            values: undefined,
            datasets: props.groupedData.datasets,
        };
    }
    else if (props.data) {
        barData = {
            status: Status.Successful,
            labels: props.data.map(function (d) { return d.label; }),
            values: props.data.map(function (d) { return [
                0.1,
                Number((d.score > 0.1 ? d.score : 0.1).toFixed(2)),
            ]; }),
            datasets: undefined,
        };
    }
    var hasRightSideData = props.rightSide &&
        props.rightSide.some(function (d) { return d.score != null && Number(d.score) > 0; });
    if (hasRightSideData) {
        rightSideData = {
            status: Status.Successful,
            labels: props.rightSide.map(function (d) { return d.label; }),
            values: props.rightSide.map(function (d) {
                return Number(Number(d.score).toFixed(2));
            }),
            userType: props.userType,
        };
    }
    return (_jsxs("div", __assign({ className: "flex dashboard-graphs-row" }, { children: [_jsx("div", __assign({ className: "graph-area-left flex flex-col" }, { children: props.noData ? (_jsx("div", __assign({ className: "flex items-center justify-center h-full min-h-48 rounded-xl bg-gray-50 border border-gray-100" }, { children: _jsx("p", __assign({ className: "text-sm text-gray-400" }, { children: "No graph data available yet" })) }))) : (_jsx(BarChart, __assign({}, barData))) })), _jsx("div", __assign({ className: "graph-area-right flex flex-col" }, { children: props.noData ? (_jsx("div", __assign({ className: "flex items-center justify-center h-full min-h-48 rounded-xl bg-gray-50 border border-gray-100" }, { children: _jsx("p", __assign({ className: "text-sm text-gray-400" }, { children: "No score data available yet" })) }))) : hasRightSideData && props.rightSide.length === 1 ? (_jsx(PieChart, __assign({}, rightSideData))) : hasRightSideData ? (_jsx(StackedBar, __assign({}, rightSideData))) : null }))] })));
};
export default DashboardGraps;
